import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';
import { AppFormProps } from '../../../../../../common/interfaces';
import { PageLayoutsFormFields, PageLayoutsFormInputs } from '../../../../pageLayouts.interface';
import { defineInputStatus } from '../../../../../../common/utils';
import { ButtonSuccess, CodeEditor } from '../../../../../../common/components';

interface Props extends AppFormProps<typeof PageLayoutsFormInputs, PageLayoutsFormFields> {}

export const PageComponentsFormView: FC<Props> = ({
  form,
  initialValues,
  formErrors,
  formName,
  formType,
  handleBack,
  handleFinish,
  handleFinishFailed,
  isFormLoading,
  validationSchema
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      layout="vertical"
      initialValues={ initialValues }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        label="Назва"
        name={ PageLayoutsFormInputs.Name }
        hasFeedback
        help={ formErrors?.name }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.name) }
        rules={ validationSchema.name }
      >
        <Input disabled={ isFormLoading } allowClear placeholder="Вкажіть назву макету"/>
      </Form.Item>

      <Form.Item
        label="Контент"
        name={ PageLayoutsFormInputs.Content }
        hasFeedback
        help={ formErrors?.content }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.content) }
        rules={ validationSchema.content }
      >
        <CodeEditor
          disableMinimap
          disabled={ isFormLoading }
          height={ 550 }
        />
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button disabled={ isFormLoading } type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
